<template>
  <button
    class="button" :class="{ 'button--disabled': this.disabled }"
    :disabled="disabled"
    @click="action"
    type="button"
  >
    <template v-if="iconName">
      <icon :name="iconName" height="16" width="16"></icon>
    </template>
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'app-button',
  props: {
    action: {
      default: () => {},
      type: Function
    },
    text: String,
    iconName: String,
    disabled: Boolean
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  $color-button-default: $color-cta-dark
  $color-button-default-hover: $color-cta
  $color-button-cta: $color-cta
  $color-button-cta-hover: $color-cta-dark
  $color-button-disabled: $signable-secondary-4-shade-3
  $color-button-disabled-dark: $signable-secondary-4-shade-1
  $color-button-inverted: #fff
  $color-button-inverted-dark: $color-grey-light
  .button
    padding: 12px $spacing-base
    background-color: #fff
    color: $color-button-default
    float: left
    font-family: inherit
    font-weight: bold
    font-size: inherit
    text-decoration: none
    border: 1px solid $color-button-default
    border-radius: 3px
    cursor: pointer
    &:hover
      background-color: $color-button-default
      color: #fff
    &--cta
      background-color: $color-button-cta
      border-color: $color-button-cta
      color: #fff
      &:hover
        background-color: $color-button-cta-hover
        border-color: $color-button-cta-hover
    &--disabled
      cursor: not-allowed
      pointer-events: none
      opacity: 0.4
      &:hover
        background-color: $color-button-disabled
        color: $color-button-disabled-dark
    &--inverted
      background-color: $color-button-inverted
      color: #000
      &:hover
        background-color: $color-button-inverted-dark
    &--mini
      padding: $spacing-xs $spacing-small
    svg,
    span
      pointer-events: none
    svg
      float: left
</style>
